import React, { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { CameraIcon } from '../../icons';
import { FILE_TYPES } from '../../constants/constants';

import avatarMillPlaceholder from '../../assets/images/avatar-mill.svg';

export interface IUploadComponentProps {
  setFieldValue: any;
  maxFiles?: number;
  accept?: string;
  fileType: string;
  propField: string;
  values: any[];
  path?: string;
  url?: string;
  disable?: boolean;
}

export const UploadComponent = ({
  setFieldValue,
  accept = 'image/*',
  maxFiles = 1,
  fileType = FILE_TYPES.IMAGE,
  propField = '',
  values,
  path,
  url,
  disable,
}: IUploadComponentProps) => {
  const { t } = useTranslation();
  const [previewUrl, setPreviewUrl] = useState('');
  const { getRootProps, getInputProps } = useDropzone({
    accept,
    maxFiles,
    onDrop: (files) => {
      const newFiles = files.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      );
      setFieldValue(propField, newFiles);
    },
  });

  useEffect(() => {
    if (fileType === FILE_TYPES.IMAGE) {
      setPreviewUrl(values && values.length ? values[0].preview : url ?? '');
    }
  }, [values]);

  return (
    <>
      {fileType === FILE_TYPES.IMAGE && (
        <div className="div-align-end">
          <div
            {...getRootProps({ className: 'image-upload upload-image-dealer' })}
          >
            <input {...getInputProps()} />
            <div
              className="image-upload-image"
              data-cy="image-upload-circle-image"
              style={{
                backgroundImage: `url(${previewUrl || avatarMillPlaceholder})`,
              }}
            >
              <aside className="button">
                <CameraIcon />
              </aside>
            </div>
          </div>
        </div>
      )}
      {fileType === FILE_TYPES.FILE && (
        <>
          <Form.Control
            className="col-sm-3 form-control-bordered mr-px"
            name="upload-file"
            value={path}
            disabled
          />
          <Button
            variant="primary"
            className="col-sm-2 btn-outline-primary btn-dealer-config"
            size="sm"
            disabled={disable}
            {...getRootProps()}
          >
            <input {...getInputProps()} />
            {t('imageUpload.button')}
          </Button>
        </>
      )}
    </>
  );
};
